import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";

import rootReducer from "./reducer";

const createStoreWithMW = applyMiddleware(thunk)(createStore);

let store;

store = createStoreWithMW(
  rootReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

export default store;



// WEBPACK FOOTER //
// ./src/store.js